import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Middle } from './Symbols/WidgetLayout';
import { wrapperCentrum, center } from './Symbols/WidgetLayoutCentrum';
import { getHasElectionStarted, getHasFirstRoundStarted } from './Utils/Getters';
import styled, { css } from 'react-emotion';
import { percentFormat } from './Utils/NumberFormatting';
import { Button } from './Components/InterestingDistricts/styles';
import withDataLoader from './Utils/withDataLoader';

export const WidgetTitle = styled.div`
	color: #fff;
	font-size: 1.5rem;
	font-weight: bold;
	margin-bottom: 1rem;
	text-align: left;
`;

const WidgetSubtitle = styled.div`
	font-size: 1.125rem;
	font-weight: bold;
	margin-bottom: 0.5rem;
`;

const centrumRight = css`
	position: relative;
	text-align: center;
	padding: 1rem;
	background-color: #fff;
	a {
		cursor: pointer;
	}
	div {
		color: #00467f;
	}
	@media (max-width:  480px) {
		padding: 0.5rem;
	}
`;

const centrumLeft = css`
	background: #00467f;
	text-align: center;
	a {
		cursor: pointer;
	}
	div {
		color: #fff;
	}
	@media (max-width:  480px) {
		padding: 0.5rem;
	}
`;

class App extends React.PureComponent {
	state = {
		regional: {
			meta: {
				count: 0,
				turnout: 0
			}
		},
		senate: {
			meta: [
				{
					id: 1,
					count: 0,
					turnout: 0
				},
				{
					id: 2,
					count: 0,
					turnout: 0
				}
			]
		},
		hasData: false
	};

	componentDidMount() {
		this.load();
	}

	componentDidUpdate() {
		if (this.props.onUpdate) {
			this.props.onUpdate();
		}
	}

	load = () => {
		this.props.loadDataAsync([
			`regional/${this.props.year}/vysledky_full.json`,
			`senate/${this.props.year}/vysledky_souhrn.json`
		]).then(
			([regionalData, senateData]) => {
				this.setState({
					senate: {
						meta: senateData.body.meta
					},
					regional: {
						meta: regionalData.body.meta
					},
					hasData: true
				})
			}).catch(console.error);
	};

	render() {
		const { regional, senate } = this.state;
		const hasRegionalStarted = getHasElectionStarted(regional.meta);
		const hasSenateFirstRoundStarted = getHasFirstRoundStarted(senate.meta[0], 0);

		return <Wrapper className={wrapperCentrum}>
			<Middle className={centrumLeft}>
				<WidgetTitle className={center}>Senátní volby</WidgetTitle>
				{hasSenateFirstRoundStarted && (
					<>
						<WidgetSubtitle>
							Volební účast: {percentFormat(senate.meta[0].turnout, 2)}
						</WidgetSubtitle>
						<WidgetSubtitle>
							Sečteno: {percentFormat(senate.meta[0].count, 2)}
						</WidgetSubtitle>
					</>
				)}
				<Button href={this.props.linkToSenate}>
					Přehled všech obvodů
				</Button>
			</Middle>
			<Middle className={centrumRight}>
				<WidgetTitle className={center}>Krajské volby</WidgetTitle>
				{hasRegionalStarted && (
					<>
						<WidgetSubtitle>
							Volební účast: {percentFormat(regional.meta.turnout, 2)}
						</WidgetSubtitle>
						<WidgetSubtitle>
							Sečteno: {percentFormat(regional.meta.count, 2)}
						</WidgetSubtitle>
					</>
				)}
				<Button reverse href={this.props.linkToRegional}>
					Přehled výsledků krajů
				</Button>
			</Middle>
		</Wrapper>;
	}
}

App.propTypes = {
	rootUrl: PropTypes.string.isRequired,
	linkToSenate: PropTypes.string.isRequired,
	linkToRegional: PropTypes.string.isRequired
};

App.defaultProps = {
	linkToSenate: 'senate-2020.html#',
	linkToRegional: 'regional-2020.html#'
};

export default withDataLoader(App);
